import { useState, useEffect } from 'react';
import TextField from '@Components/Shared/Controls/TextField';
import TranslationText from '@Components/Utilities/TranslationText';
import { trackAutocompleteSearchAction } from '@Components/Utilities/Tracking';
import { getClientWidth } from '@Components/Utilities/SandhillsUtility';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';

const FacetedSearchTextField = (props) => {

    const searchTypes = props.SearchTypeOptions.filter((o) => o.Checked);
    const [value, setValue] = useState(props.Value);
    const [oldValue, setOldValue] = useState(props.Value);
    const [searchType, setSearchType] = useState((searchTypes && searchTypes.length > 0) ? searchTypes[0].Value : '');
    const [searchTypeOptions, setSearchTypeOptions] = useState(props.SearchTypeOptions);
    const routes = useRecoilValue(atoms.routes);

    useEffect(() => {
        if (props.Value !== oldValue) {
            setValue(props.Value);
            setOldValue(props.Value);
        }
    }, [props.Value]);

    const submitOnEnterButton = (e) => {
        if (e.key === 'Enter') {
            if (props.UseAutoComplete) {
                document.getElementsByClassName('ui-autocomplete')?.[0]?.setAttribute('style', 'display: none;');
            }
            if (props.SearchBaseUrl) {
                window.location.href = props.SearchBaseUrl + encodeURIComponent(e.target.value);
            } else {
                props.RunSearch({
                    fieldName: props.FieldName,
                    value: e.target.value,
                    searchType: searchType
                });
            }
        }
    };

    const getAutoCompleteCallback = () => {
        return (event, ui) => {
            setValue('');
            if (ui.item.Url) {
                if (routes.SaveAction) {
                    trackAutocompleteSearchAction(routes.SaveAction, ui.item);
                }
                window.location.href = ui.item.Url;
            } else if (props.SearchBaseUrl) {
                window.location.href = props.SearchBaseUrl + encodeURIComponent(ui.item.value);
            } else if (props.RunSearch) {
                props.RunSearch({
                    fieldName: props.FieldName,
                    value: ui.item.value,
                    searchType: searchType
                });
            }
        }
    };

    const getAutoCompleteUrl = (e) => {
        let url = props.AutoCompleteBaseUrl + encodeURIComponent(e.target.value);
        if (props.listingType != "") {
            url += "&ListingType=" + props.listingType;
        }
        return url;
    };

    const submitClick = () => {
        if (props.MobileSearch) {
            props.ToggleMobileFilter(true);
        }
        if (props.SearchBaseUrl) {
            window.location.href = props.SearchBaseUrl + encodeURIComponent(value);
        } else {
            props.RunSearch({
                fieldName: props.FieldName,
                value: value,
                searchType: searchType
            });
        }
    };

    const handleSearchTypeChange = (option) => {
        let options = [...searchTypeOptions];
        if (option.MustBeSelectedIndividually) {
            options = options.map(item => {
                return {
                    ...item,
                    Checked: false
                };
            });
        }

        options = options.map(item => {
            return {
                ...item,
                Checked: item.Name == option.Name ? !option.Checked : option.Checked
            };
        });

        setSearchType(option.Value);
        setSearchTypeOptions(options);
    };

    return (
        <div>
            <label htmlFor={'list-search-autocomp-' + props.FieldName} className='visually-hidden'>{props.Placeholder}</label>
            {props.UseAutoComplete ?
                <TextField
                    key={"autoComplete" + props.listingType}
                    inputClass='faceted-text-input'
                    name={props.FieldName}
                    value={value}
                    type='text'
                    required={false}
                    id={'list-search-autocomp-' + props.FieldName}
                    onFieldChanged={(e) => setValue(e.target.value)}
                    focus={false}
                    placeholder={props.Placeholder}
                    autoComplete={{
                        ajaxUrl: (e) => getAutoCompleteUrl(e),
                        callback: getAutoCompleteCallback()
                    }}
                    updateField={setValue}
                    onKeyPress={submitOnEnterButton}
                    autocompleteSearchField={props.FieldName == 'keywords'}
                />
                :
                <TextField
                    inputClass='faceted-text-input'
                    name={props.FieldName}
                    value={value}
                    type='text'
                    id={'list-search-autocomp-' + props.FieldName}
                    onFieldChanged={(e) => setValue(e.target.value)}
                    placeholder={props.Placeholder}
                    onKeyPress={submitOnEnterButton}
                />}
            <button type='submit' className='ts-button faceted-search' onClick={submitClick}><span><TranslationText tKey='sandhills.search' /></span></button>
            {props.ShowSearchType && props.SearchTypeOptions.length > 0 &&
                <div className='faceted-text-input-searchType'>
                    {searchTypeOptions.map(option =>
                        <div key={option.Name} className='search-type'>
                            <label>
                                <input type={option.MustBeSelectedIndividually ? 'radio' : 'checkbox'} name='SearchType' value={option.Value} onChange={() => handleSearchTypeChange(option)} checked={option.Checked} />
                                {option.Name}
                            </label>
                        </div>)}
                </div>}
        </div>
    );
};

export default FacetedSearchTextField;